<template>
  <div>
    <flewid-dialog
      draggable
      scrollable
      persistent
      content-class="p-image-example-dialog i-dialog"
      v-if="imageExampleDialog"
      v-model="imageExampleDialog"
      width="500"
    >
      <i-product-image-dialog @close="imageExampleDialog = false" />
    </flewid-dialog>

    <v-row>
      <v-col cols="12">
        <div class="i-message i-clickable" @click="imageExampleDialog = true">
          <p class="i-text-link text-center mb-0">
            <strong
              >Click here to see product image example and
              specifications</strong
            >
          </p>
        </div>
      </v-col>

      <v-col cols="12" sm="6">
        <i-product-image
          :imageUrl="getImageByPosition(product.images, IMAGE_POSITIONS.MAIN)"
          :imagePosition="IMAGE_POSITIONS.MAIN"
          :imagePositions="IMAGE_POSITIONS"
          :viewModeOnly="viewModeOnly"
          @imageError="handleImageError"
          @newImage="handleNewImage"
          @removeImage="handleRemoveImage"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <i-product-image
          :imageUrl="getImageByPosition(product.images, IMAGE_POSITIONS.LEFT)"
          :imagePosition="IMAGE_POSITIONS.LEFT"
          :imagePositions="IMAGE_POSITIONS"
          :viewModeOnly="viewModeOnly"
          @imageError="handleImageError"
          @newImage="handleNewImage"
          @removeImage="handleRemoveImage"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <i-product-image
          :imageUrl="getImageByPosition(product.images, IMAGE_POSITIONS.BACK)"
          :imagePosition="IMAGE_POSITIONS.BACK"
          :imagePositions="IMAGE_POSITIONS"
          :viewModeOnly="viewModeOnly"
          @imageError="handleImageError"
          @newImage="handleNewImage"
          @removeImage="handleRemoveImage"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <i-product-image
          :imageUrl="
            getImageByPosition(
              product.images,
              IMAGE_POSITIONS.NUTRITIONAL_PANEL
            )
          "
          :imagePosition="IMAGE_POSITIONS.NUTRITIONAL_PANEL"
          :imagePositions="IMAGE_POSITIONS"
          :viewModeOnly="viewModeOnly"
          @imageError="handleImageError"
          @newImage="handleNewImage"
          @removeImage="handleRemoveImage"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FlewidDialog from '@/components/FlewidDialog'
import iProductImage from '../products/ProductImage'
import iProductImageDialog from '../dialogs/ProductImageDialog'

const IMAGE_POSITIONS = {
  MAIN: 'MAIN',
  LEFT: 'LEFT',
  BACK: 'BACK',
  NUTRITIONAL_PANEL: 'NUTRITIONAL_PANEL'
}

export default {
  components: {
    FlewidDialog,
    iProductImage,
    iProductImageDialog
  },

  props: {
    getImageByPosition: {
      type: Function,
      required: true
    },
    newProduct: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: () => {}
    },
    viewModeOnly: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    imageExampleDialog: false,
    IMAGE_POSITIONS
  }),

  methods: {
    handleImageError(imagePosition, e) {
      const filteredImages = this.product.images.filter(
        (image) => image.type !== imagePosition
      )

      this.product.images = [
        ...filteredImages,
        {
          type: imagePosition,
          desktop: undefined,
          url: undefined,
          image: undefined
        }
      ]
    },

    handleNewImage(imagePosition, newImageUrl, newImage) {
      let filteredImages = []

      // remove existing image (if any)
      if (this.product.images?.length > 0) {
        filteredImages = this.product.images?.filter(
          (image) => image.type !== imagePosition
        )
      }

      // add new image
      this.product.images = [
        ...filteredImages,
        {
          type: imagePosition,
          desktop: newImageUrl,
          url: newImageUrl,
          image: newImage
        }
      ]
    },

    handleRemoveImage(imagePosition) {
      this.product.images = this.product.images.filter(
        (image) => image.type !== imagePosition
      )
    }
  }
}
</script>
